/* LuxePetit "Complete the Set" add-to-cart.
   Any <form data-luxe-set-form> (single id or items[] list) is added via AJAX and
   announced with the theme's standard CartLinesUpdateEvent, so the cart drawer,
   cart page and cart bubble re-render exactly like a normal Add to cart.
   Without JS the forms still post to /cart/add. */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__luxeSetBound) {
  window.__luxeSetBound = true;

  const setLabel = (btn, text) => {
    const l = btn && btn.querySelector('[data-luxe-set-label]');
    if (l) l.textContent = text;
  };
  const statusFor = (form) => {
    const root = form.closest('[data-luxe-set-root], [data-luxe-set]');
    return root ? root.querySelector('[data-luxe-set-status]') : null;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof HTMLFormElement && event.target.matches('[data-luxe-set-form]') ? event.target : null;
    if (!form) return;
    event.preventDefault();

    const btn = form.querySelector('[data-luxe-set-btn]');
    if (!btn || btn.disabled) return;
    const original = btn.getAttribute('data-label') || '';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    setLabel(btn, 'Adding…');

    const formData = new FormData(form);
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    if (sectionIds.length) {
      formData.append('sections', [...new Set(sectionIds)].join(','));
      formData.append('sections_url', window.location.pathname);
    }

    const ids = formData.getAll('items[][id]');
    const lines = (ids.length ? ids : [formData.get('id')]).filter(Boolean).map((id) => ({ merchandiseId: String(id), quantity: 1 }));

    const deferred = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines, promise: deferred.promise }));

    const status = statusFor(form);
    try {
      const res = await fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const json = await res.json();
      const cart = await fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const ok = res.ok && !json.status;
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          didError: !ok,
          items: cart.items,
          source: 'luxe-complete-set',
          sourceId: form.id || 'luxe-set',
          itemCount: lines.length,
          sections: ok ? json.sections : undefined,
        },
      });
      if (!ok) throw json;
      btn.classList.add('is-added');
      setLabel(btn, 'Added');
      if (status) status.textContent = lines.length > 1 ? 'Added to your bag.' : 'Added to your bag.';
      setTimeout(() => {
        if (!btn.isConnected) return;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-added');
        setLabel(btn, original);
      }, 2400);
    } catch (err) {
      try { deferred.reject(err); } catch (e) {}
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      setLabel(btn, original);
      if (status) status.textContent = (err && (err.description || err.message)) || 'Sorry, that could not be added. Please try again.';
    }
  });
}
